import { render, staticRenderFns } from "./VictoryScreen.vue?vue&type=template&id=00758f30&"
import script from "./VictoryScreen.vue?vue&type=script&lang=js&"
export * from "./VictoryScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports